import { GlobalStyles, useTheme } from '@mui/material';

const RsuiteThemeBridge = () => {
  const theme = useTheme();

  return (
    <GlobalStyles
      styles={{
        ':root': {
          /* ===== Primary palette ===== */
          '--rs-primary-500': theme.palette.primary.main,
          '--rs-primary-600': theme.palette.primary.main,
          '--rs-primary-400': theme.palette.primary.main,

          /* ===== Calendar cell ===== */
          '--rs-calendar-cell-selected-bg': theme.palette.primary.main,
          '--rs-calendar-cell-selected-text': '#ffffff',

          '--rs-calendar-cell-range-bg': `${theme.palette.primary.main}22`,
          '--rs-calendar-cell-range-hover-bg': `${theme.palette.primary.main}33`,

          '--rs-calendar-cell-today-text': theme.palette.primary.main,
          '--rs-calendar-cell-today-border': theme.palette.primary.main,

          /* ===== Hover & focus ===== */
          '--rs-state-hover-bg': `${theme.palette.primary.main}14`,
          '--rs-state-focus-shadow': `0 0 0 3px ${theme.palette.primary.main}33`,

          /* ===== Buttons ===== */
          '--rs-btn-primary-bg': theme.palette.primary.main,
          '--rs-btn-primary-text': '#ffffff',
          '--rs-btn-primary-hover-bg': theme.palette.primary.main,

          /* ===== Quick ranges (Today, Yesterday, Last 7 Days) ===== */
          '--rs-picker-option-hover-bg': `${theme.palette.primary.main}14`,
          '--rs-picker-option-selected-bg': `${theme.palette.primary.main}22`,
          '--rs-picker-option-selected-text': theme.palette.primary.main,

          /* ===== Borders ===== */
          '--rs-border-primary': '#666666'
        }
      }}
    />
  );
};

export default RsuiteThemeBridge;